
import { Component, Vue } from "vue-property-decorator";

@Component
export class Logo extends Vue {

}
export default Logo
